import { createFileRoute } from "@tanstack/react-router";

import { DatevSetup } from "@/features/settings/datev/setup";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen",
)({
  component: Integrations,
});

function Integrations() {
  return (
    <div className="flex flex-col">
      <DatevSetup />
    </div>
  );
}
